import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import Alert from './Components/Alert/Alert';
import React from 'react'
import History from './Pages/Historys/Index';
import SideBar from './Components/Sidebar/Sidebar';
import TargetSMS from './Pages/SendSMS/TargetSMS/TargetSMS';
import AutoSMS from './Pages/SendSMS/AutoSMS/AutoSMS';
import AllSMS from './Pages/SendSMS/AllSMS/AllSMS';
import axios from 'axios';
import CouponList from './Pages/CouponList/CouponList';
import Info from './Pages/Order/Info/Info';
import Menu from './Pages/Order/Menu/Menu';
import MenuGroupInfo from './Pages/Order/Menu/MenuGroupInfo/MenuGroupInfo';
import MenuInfo from './Pages/Order/Menu/MenuInfo/MenuInfo';
import OptionGroupInfo from './Pages/Order/Option/OptionGroupInfo/OptionGroupInfo';
import OptionInfo from './Pages/Order/Option/OptionInfo/OptionInfo';
import MenuSoldout from './Pages/Order/MenuSoldout/MenuSoldout';
import OptionSoldout from './Pages/Order/OptionSoldout/OptionSoldout';
import MenuImage from './Pages/Order/MenuImage/MenuImage';
import Intro from './Pages/Order/Intro/Intro';
import Delivery from './Pages/Order/Delivery/Delivery';
import Area from './Pages/Order/Delivery/Area/Area';
import Fee from './Pages/Order/Delivery/Fee/Fee';
import Vat from './Pages/Vat/Vat';
import Jungsan from './Pages/Jungsan/Jungsan';
import UserInfo from './Pages/UserInfo/UserInfo';
import Stats from './Pages/Stats/Stats';

import PickupOrderHistory from './Pages/Historys/PickupOrderHistory';
import TableOrderHistory from './Pages/Historys/TableOrderHistory';

import OrderHistory from './Pages/Historys/OrderHistory';
import SMSHistory from './Pages/Historys/SMSHistory';
import CouponHistory from './Pages/Historys/CouponHistory';
import PointHistory from './Pages/Historys/PointHistory';
import BellHistory from './Pages/Historys/BellHistory';
import JungsanHistory from './Pages/Historys/JungsanHistory';
import { useDispatch, useSelector } from 'react-redux';
import { setRoute } from './redux/reducers/user';
import First from './Pages/SendSMS/AutoSMS/First/First';
import Birthday from './Pages/SendSMS/AutoSMS/Birthday/Birthday';
import Retention from './Pages/SendSMS/AutoSMS/Retention/Retention';
import Point from './Pages/SendSMS/AutoSMS/Point/Point';
import VisitTarget from './Pages/SendSMS/TargetSMS/VisitTarget/VisitTarget';
import CountTarget from './Pages/SendSMS/TargetSMS/CountTarget/CountTarget';
import RetentionTarget from './Pages/SendSMS/TargetSMS/RetentionTarget/RetentionTarget';
import PriceTarget from './Pages/SendSMS/TargetSMS/PriceTarget/PriceTarget';
import PointTarget from './Pages/SendSMS/TargetSMS/PointTarget/PointTarget';
import StoreInfo from './Pages/Order/Info/StoreInfo/StoreInfo';
import OpertaionInfo from './Pages/Order/Info/OperationInfo/OperationInfo';
import { CheckOrder } from './Pages/Order/CheckOrder';
import { CheckTabletOrder } from './Pages/TabletOrder/CheckTabletOrder';
import { CheckPickupOrder } from './Pages/PickupOrder/CheckPickupOrder';
import { CheckHotelOrder } from './Pages/HotelOrder/CheckHotelOrder';
import ReqWaiting from './Pages/Waiting/ReqWaiting';
import ReqOrder from './Pages/Order/ReqOrder';
import ReqTabletOrder from './Pages/TabletOrder/ReqTabletOrder';
import ReqPickupOrder from './Pages/PickupOrder/ReqPickupOrder';
import ReqHotelOrder from './Pages/HotelOrder/ReqHotelOrder';
import CommerceCoupon from './Pages/CommerceCoupon/CommerceCoupon';
import {
  ReactChannelIO,
} from 'react-channel-plugin';
import CommerceHistory from './Pages/Historys/CommerceHistory';
import WaitingHistory from './Pages/Historys/WaitingHistory';
import Waiting from './Pages/Waiting/Waiting';

import Customer from './Pages/CustomerList/Index';
import CustomerList from './Pages/CustomerList/CustomerList';
import MemoList from './Pages/CustomerList/MemoList';
import Setting from './Pages/Setting/Setting';
import ExpirePage from './Pages/ExpirePage/ExpirePage';
import SidebarExpire from './Components/SidebarExpire/SidebarExpire';
import SettingIndex from './Pages/Setting/SettingIndex';

//tablet menu
import TabletMenu from './Pages/TabletOrder/Menu/Menu';
import TabletMenuGroupInfo from './Pages/TabletOrder/Menu/MenuGroupInfo/MenuGroupInfo';
import TabletMenuInfo from './Pages/TabletOrder/Menu/MenuInfo/MenuInfo';
import TabletOptionGroupInfo from './Pages/TabletOrder/Option/OptionGroupInfo/OptionGroupInfo';
import TabletOptionInfo from './Pages/TabletOrder/Option/OptionInfo/OptionInfo';
import TabletMenuSoldout from './Pages/TabletOrder/MenuSoldout/MenuSoldout';
import TabletOptionSoldout from './Pages/TabletOrder/OptionSoldout/OptionSoldout';
import TabletMenuImage from './Pages/TabletOrder/MenuImage/MenuImage';
import TabletOperationInfo from './Pages/TabletOrder/OperationInfo/OperationInfo';
import TabletStaffCall from './Pages/TabletOrder/StaffCall/StaffCall';
import TabletSetting from './Pages/TabletOrder/Setting/Setting';

//pickup menu
import PickupMenu from './Pages/PickupOrder/Menu/Menu';
import PickupMenuGroupInfo from './Pages/PickupOrder/Menu/MenuGroupInfo/MenuGroupInfo';
import PickupMenuInfo from './Pages/PickupOrder/Menu/MenuInfo/MenuInfo';
import PickupOptionGroupInfo from './Pages/PickupOrder/Option/OptionGroupInfo/OptionGroupInfo';
import PickupOptionInfo from './Pages/PickupOrder/Option/OptionInfo/OptionInfo';
import PickupMenuSoldout from './Pages/PickupOrder/MenuSoldout/MenuSoldout';
import PickupOptionSoldout from './Pages/PickupOrder/OptionSoldout/OptionSoldout';
import PickupMenuImage from './Pages/PickupOrder/MenuImage/MenuImage';
import PickupOperationInfo from './Pages/PickupOrder/OperationInfo/OperationInfo';
import PickupSetting from './Pages/PickupOrder/Setting/Setting';

//hotel order
import HotelMenu from './Pages/HotelOrder/Menu/Menu';
import HotelMenuGroupInfo from './Pages/HotelOrder/Menu/MenuGroupInfo/MenuGroupInfo';
import HotelMenuInfo from './Pages/HotelOrder/Menu/MenuInfo/MenuInfo';
import HotelOptionGroupInfo from './Pages/HotelOrder/Option/OptionGroupInfo/OptionGroupInfo';
import HotelOptionInfo from './Pages/HotelOrder/Option/OptionInfo/OptionInfo';
import HotelMenuSoldout from './Pages/HotelOrder/MenuSoldout/MenuSoldout';
import HotelOptionSoldout from './Pages/HotelOrder/OptionSoldout/OptionSoldout';
import HotelMenuImage from './Pages/HotelOrder/MenuImage/MenuImage';
import HotelOperationInfo from './Pages/HotelOrder/OperationInfo/OperationInfo';
import HotelSetting from './Pages/HotelOrder/Setting/Setting';

//axios.defaults.baseURL = "http://store.nas.network/";
// axios.defaults.baseURL = 'https://store.xploit.kr/'
// axios.defaults.baseURL = 'https://store.syrupfriends.com/'
axios.defaults.baseURL = '/'

axios.defaults.headers.common['Content-Type'] = "application/json";
axios.defaults.withCredentials = true;

window.axios = axios;

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return new Promise(async (resolve, reject) => {
      const originalRequest = error.config

      if (error.response && error.response.status === 401 && error.config && !error.config.__isRetryRequest) {
        originalRequest._retry = true
        window.location = '/login';
        alertRef.current.showAlert({ title: `로그인이 필요합니다.`, isConfirm: true, confirmText: '확인', onConfirm: () => { alertRef.current.hideAlert(); } })
        resolve(false)
      } else if (error.response && (error.response.status === 400 || error.response.status >= 402)) {
        console.log(error, error.response)
        reject(false)
      }

      return Promise.reject(error)
    })
  },
)

export const alertRef = React.createRef(null)

function App() {
  const [isLogin, setIsLogin] = React.useState();
  let location = useLocation();
  const State = useSelector((state) => state.user.State)
  const expiryDay = useSelector((state) => state.user.expiryDay)

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (location.pathname === '/login') setIsLogin(false)
    else setIsLogin(true)
    dispatch(setRoute(location.pathname))
  }, [location])

  return (
    <ReactChannelIO pluginKey={'50e37813-f2ee-45d0-82ad-2d2df673fe49'} language="ko" autoBoot hideChannelButtonOnBoot={false}>{/* 채널톡 플러그인 */}
      {/* {
        ( State === 'Normal' && expiryDay <= 7 ) &&
        <div className='top-banner row'>
          <p className='new-text'>시럽프렌즈의 이용기간이 {expiryDay}일 후 만료될 예정입니다</p>
          <button className='req-chat-btn' onClick={() => window.open('https://syrupfriends.notion.site/8b2611cfd18f464098b31e719df54ad2?p=4350f3dd9ca546bc97ddb36edce3b9bd&pm=s', '_blank')}>
            <p className='req-chat'>기간 연장하기</p>
          </button>
        </div>
      } */}
      <div className='App'>
        <Alert ref={alertRef} /> {/* Alert Component 전역 렌더링 */}
        {/* {
        isLogin ? State === 'Stop' ? <SidebarExpire /> : <SideBar /> : null
      } */}
        {
          isLogin && <SideBar />
        }
        <div className='inner-view'>
          <Routes>
            <Route path='/' element={<Stats />} />{/* 통계 */}
            <Route path='/login' element={<Login />} />{/* 로그인 */}

            <Route path='/history' element={<History />}>{/* 내역 메인 */}
              <Route path="order-history" element={<OrderHistory />} />{/* 오더 내역 */}
              <Route path="pickup-order-history" element={<PickupOrderHistory />} />{/* 픽업 오더 내역 */}
              <Route path="table-order-history" element={<TableOrderHistory />} />{/* 테이블 오더 내역 */}
              <Route path="sms-history" element={<SMSHistory />} />{/* 문자 내역 */}
              <Route path="coupon-history" element={<CouponHistory />} />{/* 쿠폰 내역 */}
              <Route path="point-history" element={<PointHistory />} />{/* 포인트 내역 */}
              <Route path="bell-history" element={<BellHistory />} />{/* 벨 내역 */}
              <Route path="jungsan-history" element={<JungsanHistory />} />{/* 정산 내역 */}
              <Route path="commerce-history" element={<CommerceHistory />} />{/* 커머스 내역 */}
              <Route path='waiting-history' element={<WaitingHistory />} />{/* 웨이팅 내역 */}
            </Route>

            <Route path='/customer' element={<Customer />}>{/* 고객 정보 메인 */}
              <Route path="customer-list" element={<CustomerList />} />{/* 고객 목록 */}
              <Route path="customer-memo" element={<MemoList />} />{/* 메모 나중에 입력 목록 */}
            </Route>

            <Route path='/target-sms' element={<TargetSMS />}>{/* 타겟 문자 메인 */}
              <Route path="visit" element={<VisitTarget />} />{/* 방문일 기준 */}
              <Route path="count" element={<CountTarget />} />{/* 적립횟수 기준 */}
              <Route path="retention" element={<RetentionTarget />} />{/* 미방문 기준 */}
              <Route path="price" element={<PriceTarget />} />{/* 구매금액 기준 */}
              <Route path="point" element={<PointTarget />} />{/* 포인트 기준 */}
            </Route>

            <Route path='/auto-sms' element={<AutoSMS />}>{/* 자동문자 메인 */}
              <Route path="first" element={<First />} />{/* 첫방문 설정 */}
              <Route path="birthday" element={<Birthday />} />{/* 생일 설정 */}
              <Route path="retention" element={<Retention />} />{/* 재방문 설정 */}
              <Route path="point" element={<Point />} />{/* 적립 횟수/금액 설정 */}
            </Route>

            <Route path='/all-sms' element={<AllSMS />} />{/* 전체문자 발송 */}
            <Route path='/coupon' element={<CouponList />} />{/* 쿠폰 목록 */}
            <Route path='/commerce-coupon' element={<CommerceCoupon />} />{/* 커머스 쿠폰 목록 */}
            <Route path='/vat' element={<Vat />} />{/* 부가세 신고자료 */}
            <Route path='/jungsan' element={<Jungsan />} />{/* 정산 */}
            <Route path='/user-info/:userId' element={<UserInfo />} />{/* 고객 정보 상세 */}
            <Route path='/stats' element={<Stats />} />{/* 통계 */}
            <Route path='/waiting' element={<Waiting />} />{/* 웨이팅관리 */}

            <Route path='/setting' element={<SettingIndex />} />{/* 배너,영수증 설정 */}

            <Route path='/order/store' element={
              <CheckOrder> {/* CheckOrder -> 오더 활성화 여부 체크 */}
                <Info />{/* 오더 정보 */}
              </CheckOrder>
            }>
              <Route path="store-info" element={<StoreInfo />} />{/* 오더 매장 정보 */}
              <Route path="operation-info" element={<OpertaionInfo />} />{/* 오더 운영 정보 */}
            </Route>

            <Route path='/order/menu' element={
              <CheckOrder>
                <Menu />{/* 오더 설정 메인 */}
              </CheckOrder>
            }>
              <Route path="" element={<MenuGroupInfo />} /> {/* 오더 메뉴 그룹 목록 */}
              <Route path=":menuGroupId" element={<MenuInfo />} /> {/* 오더 메뉴 상세 정보 */}
            </Route>

            <Route path='/order/option' element={
              <CheckOrder>
                <Menu />
              </CheckOrder>
            }>
              <Route path="" element={<OptionGroupInfo />} />{/* 오더 옵션 그룹 목록 */}
              <Route path=":optionId" element={<OptionInfo />} />{/* 오더 옵션 상세 정보 */}
            </Route>

            <Route path='/order/soldout' element={
              <CheckOrder>
                <Menu />
              </CheckOrder>
            }>
              <Route path="menu" element={<MenuSoldout />} />{/* 오더 메뉴 품절 관리 */}
              <Route path="option" element={<OptionSoldout />} />{/* 오더 옵션 품절 관리 */}
            </Route>

            <Route path='/order/menu-image' element={
              <CheckOrder>
                <Menu />
              </CheckOrder>
            }>
              <Route path="" element={<MenuImage />} />{/* 오더 메뉴 이미지 관리 */}
            </Route>

            <Route path='/order/intro' element={
              <CheckOrder>
                <Menu />
              </CheckOrder>
            }>
              <Route path="" element={<Intro />} />{/* 오더 매장안내/원산지 관리 */}
            </Route>

            <Route path='/delivery' element={
              <CheckOrder>
                <Delivery />
              </CheckOrder>
            }>
              <Route path="area" element={<Area />} />{/* 배달 가능 지역 설정 */}
              <Route path="fee" element={<Fee />} />{/* 배달팁 설정 */}
            </Route>

            <Route path='req-waiting' element={<ReqWaiting />} />{/* 웨이팅 비활성화 일때 페이지 */}
            <Route path='req-order' element={<ReqOrder />} />{/* 오더 비활성화 일때 페이지 */}
            <Route path='req-tabletorder' element={<ReqTabletOrder />} />{/* 테이블 오더 비활성화 일때 페이지 */}
            <Route path='req-pickuporder' element={<ReqPickupOrder />} />{/* 픽업 오더 비활성화 일때 페이지 */}
            <Route path='req-hotelorder' element={<ReqHotelOrder />} />{/* 호텔 오더 비활성화 일때 페이지 */}
            <Route path='expire' element={<ExpirePage />} />{/* 시럽프렌즈 이용기간 만료 페이지(미사용) */}

            <Route path='/tablet-order/menu' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>{/* 태블릿 오더 관리 메인 */}
              <Route path="" element={<TabletMenuGroupInfo />} />{/* 태블릿 오더 메뉴 목록 */}
              <Route path=":menuGroupId" element={<TabletMenuInfo />} />{/* 태블릿 오더 메뉴 상세 */}
            </Route>

            <Route path='/tablet-order/option' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="" element={<TabletOptionGroupInfo />} />{/* 태블릿 오더 옵션 목록 */}
              <Route path=":optionId" element={<TabletOptionInfo />} />{/* 태블릿 오더 옵션 상세 */}
            </Route>

            <Route path='/tablet-order/soldout' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="menu" element={<TabletMenuSoldout />} />{/* 태블릿 오더 메뉴 품절 */}
              <Route path="option" element={<TabletOptionSoldout />} />{/* 태블릿 오더 옵션 품절 */}
            </Route>

            <Route path='/tablet-order/menu-image' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="" element={<TabletMenuImage />} />{/* 태블릿 오더 이미지 관리 */}
            </Route>

            <Route path='/tablet-order/info' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="" element={<TabletOperationInfo />} />{/* 태블릿 오더 운영 정보 */}
            </Route>

            <Route path='/tablet-order/setting' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="" element={<TabletSetting />} />
            </Route>

            <Route path='/tablet-order/staff-call' element={
              <CheckTabletOrder>
                <TabletMenu />
              </CheckTabletOrder>
            }>
              <Route path="" element={<TabletStaffCall />} />
            </Route>

            {/* 픽업오더 */}
            <Route path='/pickup-order/menu' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>{/* 태블릿 오더 관리 메인 */}
              <Route path="" element={<PickupMenuGroupInfo />} />{/* 태블릿 오더 메뉴 목록 */}
              <Route path=":menuGroupId" element={<PickupMenuInfo />} />{/* 태블릿 오더 메뉴 상세 */}
            </Route>

            <Route path='/pickup-order/option' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>
              <Route path="" element={<PickupOptionGroupInfo />} />{/* 태블릿 오더 옵션 목록 */}
              <Route path=":optionId" element={<PickupOptionInfo />} />{/* 태블릿 오더 옵션 상세 */}
            </Route>

            <Route path='/pickup-order/soldout' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>
              <Route path="menu" element={<PickupMenuSoldout />} />{/* 태블릿 오더 메뉴 품절 */}
              <Route path="option" element={<PickupOptionSoldout />} />{/* 태블릿 오더 옵션 품절 */}
            </Route>

            <Route path='/pickup-order/menu-image' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>
              <Route path="" element={<PickupMenuImage />} />{/* 태블릿 오더 이미지 관리 */}
            </Route>

            <Route path='/pickup-order/info' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>
              <Route path="" element={<PickupOperationInfo />} />{/* 태블릿 오더 운영 정보 */}
            </Route>

            <Route path='/pickup-order/setting' element={
              <CheckPickupOrder>
                <PickupMenu />
              </CheckPickupOrder>
            }>
              <Route path="" element={<PickupSetting />} />
            </Route>

            {/* 호텔오더 */}
            <Route path='/hotel-order/menu' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>{/* 태블릿 오더 관리 메인 */}
              <Route path="" element={<HotelMenuGroupInfo />} />{/* 태블릿 오더 메뉴 목록 */}
              <Route path=":menuGroupId" element={<HotelMenuInfo />} />{/* 태블릿 오더 메뉴 상세 */}
            </Route>

            <Route path='/hotel-order/option' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>
              <Route path="" element={<HotelOptionGroupInfo />} />{/* 태블릿 오더 옵션 목록 */}
              <Route path=":optionId" element={<HotelOptionInfo />} />{/* 태블릿 오더 옵션 상세 */}
            </Route>

            <Route path='/hotel-order/soldout' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>
              <Route path="menu" element={<HotelMenuSoldout />} />{/* 태블릿 오더 메뉴 품절 */}
              <Route path="option" element={<HotelOptionSoldout />} />{/* 태블릿 오더 옵션 품절 */}
            </Route>

            <Route path='/hotel-order/menu-image' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>
              <Route path="" element={<HotelMenuImage />} />{/* 태블릿 오더 이미지 관리 */}
            </Route>

            <Route path='/hotel-order/info' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>
              <Route path="" element={<HotelOperationInfo />} />{/* 태블릿 오더 운영 정보 */}
            </Route>

            <Route path='/hotel-order/setting' element={
              <CheckHotelOrder>
                <HotelMenu />
              </CheckHotelOrder>
            }>
              <Route path="" element={<HotelSetting />} />
            </Route>
          </Routes>
        </div>
      </div>

    </ReactChannelIO>
  );
}

export default App;
